<template>
  <div
    :class="['bto-sb-widget', 'bto-sb-accordion', 'bto-sb-widget-collapsed', ...classes, { 'bto-sb-widget-collapsed-active': expanded}]"
    ref="accordionWidget">
    <div class="bto-sb-widget-title bto-sb-widget-title-icon" @click="toggleAccordion">
      <span class="bto-sb-widget-title-icon"></span>
      <h3 class="noselect">{{title}}</h3>
      <span class="bto-sb-widget-title-arrow"></span>
    </div>
    <transition-accordion>
      <div class="accordion-transition bto-sb-widget-content noselect"
           ref="accordionContent"
           v-show="expanded">
        <slot></slot>
      </div>
    </transition-accordion>
  </div>
</template>

<script>
  import store from '../../store';
  import TransitionAccordion from '../shared/utilities/TransitionAccordion';

  export default {
    // eslint-disable-next-line
    name: 'Accordion',
    data() {
      return {
        expanded: true
      };
    },
    props: {
      expandedOnStart: {
        type: Boolean,
        default: true
      },
      classes: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
        default: ''
      }
    },
    computed: {
      leftColExpanded() {
        return store.state.LayoutModule.leftColExpanded;
      }
    },
    watch: {
      leftColExpanded() {
        this.updateHeight();
      },
    },
    created() {
      this.expanded = this.expandedOnStart;
    },
    mounted() {
      this.updateHeight();
    },
    updated() {
      this.updateHeight();
    },
    methods: {
      /**
       * Get first top visible element in slot
       */
      getFirstVisibleElement() {
        const all = this.$el.querySelectorAll('div.accordion-transition > *');
        for (let i = 0; i < all.length; i++) {
          if (all[i].style.display !== 'none' && all[i].style.visibility !== 'hidden') {
            return all[i];
          }
        }
        return null;
      },
      /**
       * Apply styles to first top element in slot
       * we need to do this so we can update accordion height if slot has changed height
       * otherwise if content is removed such as in favorites widget, scrollHeight will remain unchanged
       */
      setFirstChildStyles(el) {
        const firstChildEl = this.getFirstVisibleElement();
        if (firstChildEl) {
          const overflowState = firstChildEl.style.overflow;
          const clearState = firstChildEl.style.clear;

          firstChildEl.style.overflow = 'hidden';
          firstChildEl.style.clear = 'both';

          const factorHeight = firstChildEl.childElementCount > 1 ? firstChildEl.childElementCount * 50 : firstChildEl.childElementCount * 29;
          el.style.height = firstChildEl.scrollHeight > 0 ? `${firstChildEl.scrollHeight}px` : `${factorHeight}px`;

          firstChildEl.style.overflow = overflowState;
          firstChildEl.style.clear = clearState;
        } else {
          el.style.height = `${el.scrollHeight}px`;
        }
      },
      /**
       * Show / Hide accordion content
       */
      toggleAccordion() {
        if (!store.state.LayoutModule.leftColExpanded && this.isAccordionInLeftCol()) {
          return;
        }
        this.expanded = !this.expanded;
      },
      /**
       * Check if accordion is contained in left column
       * @returns {boolean}
       */
      isAccordionInLeftCol() {
        const parent = document.querySelectorAll('div.bto-short-col');
        if (!parent.length) {
          return false;
        }
        const child = this.$refs.accordionWidget;
        let node = child.parentNode;
        while ( node != null ) {
          if (node === parent[0]) {
            return true;
          }
          node = node.parentNode;
        }
        return false;
      },
      /**
       * Update accordion height if content changes and on start also
       */
      updateHeight() {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.expanded) {
              const el = this.$refs.accordionContent;
              this.setFirstChildStyles(el);
            }
          }, 0);
        });
      }
    },
    components: {
      TransitionAccordion
    }
  }
</script>

<style scoped>
  .accordion-transition {
    overflow: hidden;
    transition: 150ms ease-out;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }
</style>